export const MAX_WAGE = 500;
export const isWageValid = (grossWage: number) => grossWage <= MAX_WAGE;

export const MAX_PRO_COUNT = 1000;
